module.exports = __webpack_public_path__ + "media/auto_history/odnalezienie-d56133e3.png";